import { render, staticRenderFns } from "./MenuTabItem.vue?vue&type=template&id=d0d6643c&scoped=true&"
import script from "./MenuTabItem.vue?vue&type=script&lang=js&"
export * from "./MenuTabItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuTabItem.vue?vue&type=style&index=0&id=d0d6643c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d6643c",
  null
  
)

export default component.exports